@if (item?.itemId) {
    <div class="flex align-items-center gap-2 flex-wrap">
        <div class="flex align-items-center gap-2 min-w-0 flex-1"
            [class.cursor-pointer]="linkable"
            [routerLink]="linkable ? '/item/' + item.itemId : null">
            @if (item.photoId) {
                @defer (on viewport) {
                    <app-image-loader
                        [documentId]="item.photoId"
                        [width]="45"
                        [height]="45"
                        [title]="item.numero" />
                }
                @placeholder {
                    <div class="flex align-items-center justify-content-center" style="height: 45px; width: 45px;">
                        <p-skeleton width="45px" height="45px"></p-skeleton>
                    </div>
                }
            }
            <div class="flex flex-column gap-1 min-w-0">
                @if (linkable) {
                    <a class="font-bold text-overflow-ellipsis overflow-hidden white-space-nowrap"
                        [routerLink]="'/item/' + item.itemId">
                        {{ item.numero | valeurVide }}
                    </a>
                } @else {
                    <span class="font-bold text-overflow-ellipsis overflow-hidden white-space-nowrap">
                        {{ item.numero | valeurVide }}
                    </span>
                }
                <span class="champConsultation text-overflow-ellipsis overflow-hidden">
                    {{ item.description | valeurVide }}
                </span>
            </div>
        </div>
        @if (editable) {
            <p-button
                type="button"
                label="Changer l'unité"
                icon="pi pi-sync"
                severity="secondary"
                [outlined]="true"
                styleClass="flex-shrink-0"
                pTooltip="Sélectionner une autre unité"
                [attr.aria-label]="'Changer l\'unité'"
                (onClick)="edit.emit()" />
        }
    </div>
} @else {
    <div class="flex flex-column gap-2">
        <span class="champConsultation text-color-secondary">Aucune unité sélectionnée</span>
        @if (editable) {
            <p-button
                type="button"
                label="Sélectionner une unité"
                icon="pi pi-search"
                severity="secondary"
                [outlined]="true"
                styleClass="w-full md:w-auto"
                (onClick)="edit.emit()" />
        }
    </div>
}
